export const SELECT_TEMP_TOOTH_FOR_EXAM = "SELECT_TEMP_TOOTH_FOR_EXAM";
export const SELECT_CONDITION_FOR_TOOTH_FOR_EXAM =
  "SELECT_CONDITION_FOR_TOOTH_FOR_EXAM";

export const CHANGE_SUBJECT_VALUES = "CHANGE_SUBJECT_VALUES";
export const RESET_ALL_CASE_REGISTERATION_FORM =
  "RESET_ALL_CASE_REGISTERATION_FORM";

export const SET_EXAME_METHODS = "SET_EXAME_METHODS";
export const CLEAR_EXAME_METHODS = "CLEAR_EXAME_METHODS";
export const SET_CURRENT_CASE_DETAILS = "SET_CURRENT_CASE_DETAILS";
export const CLEAR_CURRENT_CASE_DETAILS = "CLEAR_CURRENT_CASE_DETAILS";
export const RESET_CURRENT_COMPLETED_TOOTH = "RESET_CURRENT_COMPLETED_TOOTH";

export const _onSelectTempTeethForAgeAssessment = (tooth_id) => {
  return (dispatch) => {
    dispatch({
      type: SELECT_TEMP_TOOTH_FOR_EXAM,
      payload: tooth_id,
    });
  };
};
export const _onSelectConditionForTeethForAgeAssessment = (condition) => {
  return (dispatch) => {
    dispatch({
      type: SELECT_CONDITION_FOR_TOOTH_FOR_EXAM,
      payload: condition,
    });
  };
};
export const _onChangeSubjectRegistrationFormValues = (field, value) => {
  return (dispatch) => {
    dispatch({
      type: CHANGE_SUBJECT_VALUES,
      payload: { field, value },
    });
  };
};
export const _onResetCaseRegistrationForm = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_ALL_CASE_REGISTERATION_FORM,
    });
  };
};
export const _onSetExamMethods = (data) => {
  return (dispatch) => {
    dispatch({
      type: SET_EXAME_METHODS,
      payload: data,
    });
  };
};
export const _onClearExamMethods = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_EXAME_METHODS,
    });
  };
};
export const _onSetCurrentCaseDetails = (data) => {
  return (dispatch) => {
    dispatch({
      type: SET_CURRENT_CASE_DETAILS,
      payload: data,
    });
  };
};
export const _onClearCurrentCaseDetails = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_CURRENT_CASE_DETAILS,
    });
  };
};
export const _onRsetCurrentCompletedTooth = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_CURRENT_COMPLETED_TOOTH,
    });
  };
};
